import React from 'react';
import PropTypes from 'prop-types';
import Default from '../../assets/images/default_placeholder.png';
import styled from 'styled-components';

const ImageContainer = styled.div`
  display: block;
  overflow: hidden;
  width: 100%;
  border-radius: ${props => (props.radius ? props.radius : 0)};
`;

const Image = styled.div`
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

class ImageComponent extends React.Component {
  state = {
    color: 'FFF',
    result: Default
  };

  componentDidMount() {
    const { image, url } = this.props;
    this.setImage(image, url);
  }
  componentWillReceiveProps(nextProps) {
    const { image, url } = nextProps;
    if (image !== this.props.image || url !== this.props.url) {
      this.setImage(image, url);
    }
  }

  setImage = (image, url) => {
    let { color, result } = this.state;
    if (image) {
      color = image.color ? image.color : '#FFF';
      result = image.url;
    }
    if (url) {
      result = url;
    }
    this.setState({ color: color, result: result });
  };

  render() {
    const { width, ratio, radius, children, height } = this.props;
    const { color, result } = this.state;
    return (
      <ImageContainer
        radius={radius}
        ref={component => (this.component = component)}
      >
        <Image
          style={{
            width: width ? width : '100%',
            paddingTop: height ? height : ratio ? 100 * ratio + '%' : '100%',
            backgroundColor: color,
            backgroundImage: `url(${result})`
          }}
        />
        {children}
      </ImageContainer>
    );
  }
}
ImageComponent.propTypes = {
  image: PropTypes.object,
  url: PropTypes.string,
  radius: PropTypes.string,
  ratio: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.string
};
export default ImageComponent;



// WEBPACK FOOTER //
// ./src/components/Images/ImageComponent.js